<template>
  <div class="ma-2">
    <v-data-table
      :headers="headers"
      :items="itens"
      :options.sync="options"
      :server-items-length="totalItens"
      :loading="loading"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 50, 100],
        showFirstLastPage: true,
        itemsPerPageText: 'Itens por página',
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
      @page-count="pageCount = $event">
        <template v-slot:top>
          <v-form @submit="pesquisar()" v-on:submit.prevent>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select clearable v-model="pesquisa.cc_fil" label="Empresa" placeholder="" :items="filiais" item-text="cc_fil" item-value="cc_fil"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-text-field clearable v-model="pesquisa.cc_emp" label="Código" placeholder=""></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                  <v-text-field clearable v-model="pesquisa.nm_emp" label="Nome" placeholder=""></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                  <v-btn depressed outlined color="primary" type="submit">
                    pesquisar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab color="primary" v-on="on" @click="editar(item)" class="mr-1">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>
            <span>Edição</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn depressed small fab color="primary" v-on="on" @click="deletar(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Remoção</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-card outlined>

        <v-toolbar flat color="accent">
          <v-toolbar-title>Cadastrar/Alterar Empregado
            <v-chip
              color="primary"
              v-if="empregado.id_reg != undefined"
              close
              @click:close="resetarFormulario()">
              {{ empregado.cc_emp }}, {{ empregado.nm_emp }}
            </v-chip>
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-form  ref="form" @submit="salvar()" v-model="valid" :lazy-validation="lazy" id="edit-form" v-on:submit.prevent>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select item-text="cc_fil" item-value="cc_fil" label="Empresa" :items="filiais" v-model="empregado.cc_fil" :rules="validacao.cc_fil" :disabled="disabled"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select item-text="ds_per" item-value="cc_per" label="Perfil" :items="perfis" v-model="empregado.cc_per" :rules="validacao.cc_per"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-text-field label="Código" v-model="empregado.cc_emp" :rules="validacao.cc_emp" :disabled="disabled"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                  <v-text-field label="Nome" v-model="empregado.nm_emp" :rules="validacao.nm_emp"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" lg="2" xl="2">
                  <v-text-field label="% Desconto" type="number" hint="Limite de desconto" persistent-hint v-model="empregado.pc_lim_des" :rules="validacao.pc_lim_des"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="Senha" type="password" prepend-inner-icon="mdi-lock" clearable v-model="empregado.pw_emp_log_1_t"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="Confirma Senha" type="password" prepend-inner-icon="mdi-lock" clearable v-model="empregado.pw_emp_log_2_t"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                  <v-btn depressed outlined color="primary" type="submit">{{ empregado.id_reg != undefined ? 'CONFIRMAR ALTERAÇÕES' : 'CONFIRMAR INSERÇÃO'}}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>

  </div>
</template>
<script>
  import lodash from 'lodash'
  import md5 from 'md5'
  export default {

    components: {

    },

    data () {
      return {

        /** atributos da paginacao */
        page: 1,
        pageCount: 0,
        itemsPerPage: 5,
        totalItens: 0,
        itens: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Empresa', value: 'cc_fil', sortable:false, width: 80 },
          { text: 'Código', value: 'cc_emp', sortable:false, width: 100 },
          { text: 'Perfil', value: 'cc_per', sortable:false, width: 90 },
          { text: 'Nome', value: 'nm_emp', sortable:false},
          { text: '% Desconto', value: 'pc_lim_des', sortable:false, width:90, align:'right'},
          { text: '', value: 'action', sortable:false, width: 120, align: 'right' },
        ],

        /** atributos da pesquisa*/
        pesquisa: {
          cc_fil: undefined,
          cc_emp: undefined,
          nm_emp: undefined,
        },

        /** propriedades de persistencia*/
        lazy: false,
        valid: true,
        disabled: false,

        filiais:[],
        perfis:[
            {cc_per:'OPE', ds_per:'Operador'},
            {cc_per:'VEN', ds_per:'Vendedor'},
            {cc_per:'GER', ds_per:'Gerente'},
        ],

        empregado: {
          id_reg: undefined,
          cc_fil: undefined,
          cc_emp: undefined,
          nm_emp: undefined,
          pw_emp_log: undefined,
          pw_emp_log_2_t: undefined,
          pw_emp_log_1_t: undefined,
          bl_emp_log: true,
          pc_lim_des: 0.00
        },

        validacao: {
          cc_fil:[
            (v) => !!v || 'Requerido',
          ],
          cc_emp:[
            (v) => !!v || 'Requerido',
            (v) => /^[0-9A-Za-z]*$/.test(v) || 'Formato inválido'
          ],
          cc_per:[
            (v) => !!v || 'Requerido',
          ],
          nm_emp:[
            (v) => !!v || 'Requerido',
          ],
          pc_lim_des: [
            (v) => !!v || 'Requerido',
            //(v) => /^[0-9]*[.][0-9]+$/.test(v) || 'Formato inválido'
            (v) => { if(v === undefined || v < 0) {return 'Requerido'} else { return true } }
          ]
        },

      }
    },

    computed: {
      validaSenha() {
        return () => {
          if(((this.empregado.pw_emp_log_1_t !== undefined && this.empregado.pw_emp_log_1_t !== '') || 
              (this.empregado.pw_emp_log_2_t !== undefined && this.empregado.pw_emp_log_2_t !== '')) &&
              this.empregado.pw_emp_log_1_t !== this.empregado.pw_emp_log_2_t){
              return 'Não confere'
          } else {
              return true
          }
        }
      }
    },

    watch: {
      options: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              this.itens = data.items
              this.totalItens = data.total
              this.pageCount = data.totalPages
            })
        },
        deep: true,
      },
    },

    mounted () {

      this.getDataFromApi()
        .then(data => {
          this.itens = data.items
          this.totalItens = data.total
        })

      this.populaFiliais()

    },

created(){
      this.$vuetify.goTo(0)
    },
    
    methods: {

      editar(obj){

        this.disabled = true
        this.empregado = lodash.clone(obj)
        this.$vuetify.goTo('#edit-form', {duration: 500,
          offset: 0,
          easing: 'linear',
        })
      },

      deletar(obj) {
        if (confirm('Deseja realmente deletar este registro?')) {
          this.$store.dispatch('deletarEmpregado', obj.id_reg).then(() => {
            var removeIndex = this.itens.map(function(item) { return item.id_reg; }).indexOf(obj.id_reg);
            if(this.empregado.id_reg === this.itens[removeIndex].id_reg){
              this.resetarFormulario()
            }
            this.itens.splice(removeIndex, 1);
          }).catch(err => {
            console.log(err)
          })
        } 
      },

      salvar() {

        if (this.$refs.form.validate()) {

          // eslint-disable-next-line no-debugger
          debugger
          let senhaValidada = true
          
          // inserindo
          if(this.empregado.id_reg === undefined && (this.empregado.pw_emp_log_1_t === undefined || this.empregado.pw_emp_log_1_t.trim() === '')){
            senhaValidada = false
            alert('A senha precisa ser informada')
          }

          if(this.empregado.pw_emp_log_1_t !== undefined || this.empregado.pw_emp_log_1_t.trim() !== '') {
            if(this.empregado.pw_emp_log_1_t != this.empregado.pw_emp_log_2_t){
              alert('Confirmação de senha inválida')
              senhaValidada = false
            }
          }

          //this.empregado.pw_emp_log = undefined
          this.empregado.bl_emp_log = true
          if(this.empregado.pw_emp_log_1_t !== undefined && this.empregado.pw_emp_log_1 !== ''){
            this.empregado.pw_emp_log = md5(this.empregado.pw_emp_log_1_t)
          }

          if(senhaValidada){
            this.$store.dispatch('salvarEmpregado', this.empregado).then(() => {

              if(this.empregado.id_reg !== undefined) {
                let item = this.itens.filter((el) => {return el.id_reg === this.empregado.id_reg})
                if(item.length > 0){
                  Object.assign(this.itens[this.itens.indexOf(item[0])], this.empregado)
                }
              }

              this.resetarFormulario()
            }).catch(err => {
              console.log(err)
            })
          }

        }
      },

      resetarFormulario() {
        this.disabled = false
        this.empregado.id_reg = undefined
        this.empregado.pw_emp_log = undefined
        this.$refs.form.reset()
      },

      pesquisar() {
        this.resetarFormulario()
        this.page = 1
        this.getDataFromApi()
          .then(data => {
            this.itens = data.items
            this.totalItens = data.total
          })
      },

      populaFiliais() {
        this.$store.dispatch('obterFiliais', {}).then(resp => {
          this.filiais = resp.data.content
        }).catch(err => {
          console.log(err)
        })
      },

      getDataFromApi () {

        this.loading = true

        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {

          // eslint-disable-next-line no-unused-vars
          const { sortBy, sortDesc, page, itemsPerPage } = this.options

          let params = {
            page: page-1,
            size: itemsPerPage === -1 ? 999999999 : itemsPerPage,
            cc_psr_ccl:'P'
          };

          let filtro = lodash.omitBy(Object.assign(params, this.pesquisa), o => !o)

          this.$store.dispatch('pesquisaEmpregado', filtro).then( resp => {

            this.loading = false

            let items        = resp.data.content
            const total      = resp.data.totalElements
            const totalPages = resp.data.totalElements

            resolve( { items, total, totalPages } )

          }).catch( err => {
            console.log(err)
          })

        })
      }
    },
  }
</script>